import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { fadeUp, fadeUpChild, stagger, viewportOnce } from "./anim";
import { writing } from "@/data/resume";

export const Writing = () => {
  return (
    <section
      id="writing"
      data-testid="writing"
      className="relative border-y border-black/10 bg-[#F1EFE8]"
    >
      <div className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-36">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between"
        >
          <div>
            <span className="font-mono-x text-xs uppercase tracking-[0.3em] text-[#9A7526]">
              (07) — Thoughts & Writing
            </span>
            <h2 className="mt-6 font-display text-4xl font-light tracking-tight text-[#1A1A18] md:text-6xl">
              Notes on customer success.
            </h2>
          </div>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-1 gap-px overflow-hidden border border-black/10 bg-black/10 md:grid-cols-3"
        >
          {writing.map((post, i) => (
            <motion.a
              key={i}
              href={post.url}
              target={post.url !== "#" ? "_blank" : undefined}
              rel="noopener noreferrer"
              variants={fadeUpChild}
              data-testid={`writing-card-${i}`}
              className="group flex flex-col justify-between bg-[#FFFFFF] p-8 transition-colors duration-500 hover:bg-[#FFFFFF] md:p-10"
            >
              <div>
                <span className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-[#9A7526]">
                  {post.tag}
                </span>
                <h3 className="mt-5 font-display text-2xl font-light leading-snug text-[#1A1A18] md:text-3xl">
                  {post.title}
                </h3>
                <p className="mt-4 font-body text-sm font-light leading-relaxed text-[#6E6D66]">
                  {post.excerpt}
                </p>
              </div>
              <div className="mt-10 flex items-center gap-2 font-mono-x text-[11px] uppercase tracking-[0.2em] text-[#1A1A18]">
                Read more
                <ArrowRight
                  size={14}
                  className="text-[#9A7526] transition-transform duration-300 group-hover:translate-x-1.5"
                />
              </div>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
